// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"I2-z","dimensionLabel":"J2-z","styleChooserControlWrapper":"K2-z","styleChooserControl":"L2-z","disabled":"M2-z","giftCard":"N2-z","styleChooserText":"O2-z"};